import * as React from "react";

function SvgIcons8OpenGarageDoor(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M16 3.906l-.406.18L4 9.238V28h6V15h12v13h6V9.238L16 3.906zm0 2.188l10 4.445V26h-2V13H8v13H6V10.54l10-4.446zm0 11.492l-3.707 3.707 1.414 1.414L15 21.414V26h2v-4.586l1.293 1.293 1.414-1.414L16 17.586z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8OpenGarageDoor);
